import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const TABS = [
  { label: "Expenses",           path: "/accounting/expenses" },
  { label: "Other Income",       path: "/accounting/income" },
  { label: "Recurring Expenses", path: "/accounting/recurring-expenses" },
] as const;

export const AccountingTabs: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="flex items-center gap-1 mb-2 overflow-x-auto">
      {TABS.map((tab) => {
        const isActive = location.pathname.startsWith(tab.path);
        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={`text-sm font-medium px-4 py-2 rounded-xl transition-colors whitespace-nowrap ${
              isActive
                ? "bg-gradient-to-r from-[#00b8db] to-[#2b7fff] text-white shadow-sm"
                : "text-[#314158] hover:bg-white/60"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default AccountingTabs;
